import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Parser from 'html-react-parser';
import Header from './DataComponent__TableHeader';
import Loading from '../Loading';
import UserStore from '../../stores/UserStore';

function DataComponentTable({
                                loading = false,
                                data = [],
                                className = '',
                                headerNames = [],
                                multiLevelHeaderNames = [],
                                columnData = { header: [], body: [] },
                            }) {
    const t = useMemo(() => UserStore.getTranslation(), []);
    const staticNames = t?.dataTable || { noData: 'No data' };

    return (
        <div className="loading-wrapper">
            {loading && data.length ? <div className="loading-wrapper__item"><Loading /></div> : null}
            <div className="table-responsive">
                <table className={`table table-data ${className}`}>
                    <Header
                        headerNames={headerNames}
                        multiLevelHeaderNames={multiLevelHeaderNames}
                        columnData={columnData.header}
                    />
                    <tbody>
                    {data.map((item, i) => {
                        const { className: rowCls, ...rest } = item || {};
                        const key = React.isValidElement(rest?.id) ? i : (rest?.id ?? i);
                        return (
                            <tr key={key} className={rowCls}>
                                {Object.keys(rest).map((k, j) => {
                                    const cellCfg = columnData.body?.[j] || {};
                                    let value;
                                    if (typeof rest[k] === 'object') value = rest[k];
                                    else if (typeof rest[k] === 'string') value = Parser(rest[k]);
                                    if (value === undefined) return null;
                                    return <td className={k} key={j} {...cellCfg}>{value}</td>;
                                })}
                            </tr>
                        );
                    })}
                    </tbody>
                </table>

                {!data.length ? (loading ? <Loading center /> : <div className="text-center table-notfound-sign">{staticNames.noData}</div>) : null}
            </div>
        </div>
    );
}

DataComponentTable.propTypes = {
    loading: PropTypes.bool,
    data: PropTypes.array,
    className: PropTypes.string,
    headerNames: PropTypes.array,
    multiLevelHeaderNames: PropTypes.array,
    columnData: PropTypes.shape({ header: PropTypes.array, body: PropTypes.array }),
};

export default DataComponentTable;
